export default __webpack_public_path__ + "static/media/theme6.e99f6bf7.jpg";